export default {
  locale: "tc",
  language: {
    name: "中文",
    Language: "語言",
  },
  navbar: {},
  summary: {
    tonext: "距下一周期還有",
    blocks: "區塊",
    totaltext1: "節點",
    totaltext2: "總數",
    totaltext: "節點總數",
    consensustext1: "共識",
    consensustext2: "節點",
    consensustext: "共識節點",
    candidatetext1: "候選",
    candidatetext2: "節點",
    candidatetext: "候選節點",
    synchronoustext1: "同步",
    synchronoustext2: "節點",
    synchronoustext: "同步節點",
    totalstake: "總質押量",
    oftotal: "佔ONT總流通量比例",
    increse: "排名提升",
    increseexplain: "（自上一週期）",
    applynow: "北鬥節點申請已開啟！ 點此申請",
    calculator: "節點與質押收益測算器",
    launchapp: "啟動應用程式",
  },
  nodelist: {
    cnode: "共識節點",
    nnode: "候選節點",
    rank: "#",
    checkmark: "標籤",
    long: "長期運營",
    verified: "已驗證聯繫方式",
    stable: "收益分配比例穩定",
    harbinger: "本體社區貢獻者",
    badActor: "不良信譽",
    risky: "劇烈升高",
    checkdesc: "查看節點標籤詳情:",
    checkurl:
      "https://ontology-1.gitbook.io/ontology-node-staking-cn/jie-dian-biao-qian",
    rankDesc: "自上一週期",
    verification: "已驗證節點",
    name: "名稱",
    top49: "狀態",
    top49Desc: "到本周期結束時依然排名前49名的節點將獲得基金會獎勵",
    location: "地區",
    lastblocks: "最新區塊",
    blockproduced: "生成區塊",
    income: "上一周期手續費收益（ONG）",
    fee: "質押使用者收益比例",
    progress: "質押進度",
    stake: "質押",
    stakeurl: "https://mp.weixin.qq.com/s/LqmfcDEZTQGEaQAOrjNQyg",
    initpos: "初始質押量",
    totalstake: "總質押量",
    reward1:
      "這是節點選擇的在下一輪共識中,分享給授權質押用戶的節點自身質押部分ONT和使用者質押部分ONT收到的手續費收益和解綁ONG收益的比例 ",
    annual: "年收益率",
    annual1: "此預估數據根據即時網路運行,質押情況以及ONT、ONG價格計算所得",
    notopen: "暫未公開",
    gccurl:
      "https://medium.com/@theontologyteam/%E6%9C%AC%E4%BD%93%E5%85%A8%E7%90%83%E7%A4%BE%E5%8C%BA%E8%B4%A1%E7%8C%AE%E8%80%85%E8%AE%A1%E5%88%92-ontology-global-community-contributor-gcc-%E7%8E%B0%E5%B7%B2%E5%BC%80%E6%94%BE%E7%94%B3%E8%AF%B7-eb16151d4793",
  },
  cobuild: {
    title: "共建節點",
  },
  detail: {
    title: "節點資訊",
    name: "名稱",
    position: "地區",
    address: "錢包位址",
    website: "網站",
    social: "社交平臺",
    pk: "公鑰",
    ontid: "ONT ID",
    transactions: "交易數",
    transfers: "轉帳數",
    stakeamount: "節點質押量",
    userstake: "使用者質押",
    description: "簡介",
    rank: "排名",
  },
  tab: {
    balance: "餘額",
    transactions: "交易",
    voter: "選民",
    transfer: "轉帳",
    balanceValue: "balance",
    transactionsValue: "transactions",
    voterValue: "voter",
    transferValue: "transfer",
  },
  back: {
    back: "返回",
  },
  balance: {
    name: "TOKEN",
    type: "類型",
    balance: "餘額",
  },
  voter: {
    address: "位址",
    vote: "質押量",
    percent: "總百分比",
  },
  tx: {
    hash: "HASH",
    status: "狀態",
    block: "區塊",
    time: "時間",
    fee: "手續費",
    result: "結果",
    height: "",
    from: "發送人",
    to: "接收人",
    amount: "數額",
    token: "TOKEN",
    way: "",
  },
  stake: {
    progress: "質押週期",
    round1: "（第",
    round2: "輪）",
    days: "天",
    hours: "小時",
    left: "剩餘",
    currnetround1: "當前周期（預估）",
    currnetround: "當前週期",
    blocks: "區塊",
    guide: "質押指引",
    onto: "ONTO",
    owallet: "OWallet",
    historyround: "週期",
    startheight: "開始塊高",
    endheight: "結束塊高",
    starttime: "開始時間",
    endtime: "結束時間",
    processing: "進行中",
  },
  onto: {
    url:
      "https://ontology-1.gitbook.io/ontology-node-staking-cn/cao-zuo-zhi-yin/shi-yong-onto-can-yu-ben-ti-jie-dian-zhi-ya",
    guideText: "使用ONTO參與本體節點質押",
    item1: "Step 1: ",
    item2: "下載 ",
    item3: "ONTO",
    item4: "https://app.ont.io/socialmedia/pic/cnimage019.png",
    item5: "Step 2: ",
    item6: "打開ONTO,點擊",
    item7: "資產",
    item8: "進入,然後點擊",
    item9: "ONT",
    item10: "  ",
    item11: "https://app.ont.io/socialmedia/pic/cnimage021.png",
    item12: "Step 3: ",
    item13: "點擊左下角",
    item14: "質押",
    item15: ",進入質押頁面 ",
    item16: "https://app.ont.io/socialmedia/pic/cnimage023.png",
    item17: "Step 4: ",
    item18: "點擊",
    item19: "推薦質押節點",
    item20: ",選擇想要質押的節點,並輸入質押數量（須為1 ONT的整數倍） ",
    item21: "備註:",
    item22: '如果您想要質押1 ONT,請輸入"1",確認資訊后,點擊',
    item23: "立即質押",
    item24: ",輸入密碼后完成質押 ",
    item25: "https://app.ont.io/socialmedia/pic/cnimage025.png",
    item26: "https://app.ont.io/socialmedia/pic/cnimage027.png",
    item27: "Step 5: ",
    item28: "授權完成後,可在",
    item29: "我的質押",
    item30: "頁面中查看相關信息 ",
    item31: "https://app.ont.io/socialmedia/pic/cnimage029.png",
    item32: "點擊左下角",
    item33: "領取收益",
    item34: "可進行ONG提取 ",
    item35: "",
    item36: "",
    item37: "https://app.ont.io/socialmedia/pic/cnimage031.png",
    item38: "如何取消質押？ ",
    item39: "在",
    item40: "我的質押",
    item41: "頁面中點擊",
    item42: "取消質押",
    item43: "取消之前請點擊右上角",
    item44: "說明",
    item45: "仔細閱讀細則 取消後可點擊",
    item46: "提取",
    item47: ",取出您的ONT ",
    item48: "",
    item49: "",
    item50: "https://app.ont.io/socialmedia/pic/cnimage029.png",
    ontoappurl: "https://onto.app/",
  },
  owallet: {
    url:
      "https://ontology-1.gitbook.io/ontology-node-staking-cn/cao-zuo-zhi-yin/shi-yong-owallet-can-yu-ben-ti-jie-dian-zhi-ya",
    guideText: "使用OWallet參與本體節點質押",
    item1: "Step 1: ",
    item2: "下載 ",
    item3: "OWallet",
    item4: " (Windows/macOS/Linux)",
    item5: "https://app.ont.io/socialmedia/pic/enimage001.png",
    item6: "Step 2: ",
    item7: "打開OWallet,選擇",
    item8: "節點授權質押",
    item9: "https://app.ont.io/socialmedia/pic/cnimage003.png",
    item10: "Step 3: ",
    item11:
      "查看節點列表,選定節點後點擊後方箭頭,選擇ONT存放錢包,再進入節點授權頁面 ",
    item12: "備註:",
    item13: "點擊右上角",
    item14: "我的質押",
    item15: ",可查看已完成的質押 ",
    item16: "https://app.ont.io/socialmedia/pic/cnimage005.png",
    item17: "溫馨提示:",
    item18: "您可以通過對比投資回報率,選擇您認為收益較高的節點 ",
    item19: "OWallet同時直支援使用Ledger錢包進行質押 ",
    item20: "https://app.ont.io/socialmedia/pic/cnimage007.png",
    item21: "Step 4: ",
    item22: "點擊",
    item23: "提交新的質押授權",
    item24:
      "輸入想要質押的ONT單元數量,每1個ONT為一個最小質押單元 輸入密碼后點擊確認完成質押 ",
    item25: "https://app.ont.io/socialmedia/pic/cnimage009.png",
    item26: "https://app.ont.io/socialmedia/pic/cnimage011.png",
    item27: "如何取消質押？ ",
    item28: "點擊",
    item29: "取消授權質押",
    item30: ",輸入要取消的數量 ",
    item31: "https://app.ont.io/socialmedia/pic/cnimage013.png",
    item32: "https://app.ont.io/socialmedia/pic/cnimage015.png",
    item33: "如何提取質押收益？ ",
    item34: '點擊"提取"來提取收益',
    item35: "",
    item36: "https://app.ont.io/socialmedia/pic/cnimage017.png",
    owalleturl: "https://github.com/ontio/OWallet/releases",
  },
  calculator: {
    title: "節點與質押收益測算器",
    node: "節點使用者",
    user: "質押使用者",
    choosenodetype: "請選擇您想要運營的節點類型",
    choosenodetypeuser: "請選擇您想要質押的節點",
    typemsg: "具體收益測算公式,請參考此手冊 ",
    doc: "本體質押收益計算手冊",
    url:
      "https://node.ont.io/%E6%9C%AC%E4%BD%93%E8%B4%A8%E6%8A%BC%E6%94%B6%E7%9B%8A%E8%AE%A1%E7%AE%97%E6%89%8B%E5%86%8C_202109.pdf",
    cnode: "共識節點",
    nnode: "候選節點",
    stakeamount: "預計質押數量（ONT）",
    stakeamountuser: "您想要質押的ONT個數（ONT）",
    amountMsg1: "成為共識節點當前至少需要質押:",
    amountMsg2: "成為候選節點當前至少需要質押:",
    amountMsg3: "成為候選節點至多需要質押的ONT數量:",
    reward: "節點收益分配比例%（節點方保留收益比例）",
    result: "測算結果",
    totalincome: "總收益: ",
    totalrate: "預計總收益率: ",
    totalong: "預計總收益ONG個數:",
    detail: "詳情",
    feerate: "預計手續費收益率:",
    feeong: "預計手續費收益ONG個數:",
    releaserate: "預計解綁ONG收益率:",
    releaseong: "預計解綁ONG收益個數:",
    foundationrate: "預計基金會獎勵收益率:",
    foundationong: "預計基金會獎勵ONG個數:",
    choosenode: "選擇節點",
    maxstakeMsg: "該節點最多可以質押: ",
    nodeChangeMsg:
      "您的質押會導致該節點在下周期成為共識節點,收益會發生變化,具體計算規則請參考",
    calc: "測算",
    disclaimtitle: "免責申明:",
    disclaimq: "How accurate is this calculation?",
    disclaima:
      "注意:測算數據受ONT/ONG價格,全網質押ONT總數,單個節點質押ONT數量等因素影響,實時變動,僅作參考 ",
  },
  footer: {
    flag: "zh",
    Development: "開發",
    DeveloperCenter: "開發者中心",
    dApp: "dApp 資訊",
    Tutorials: "教程",
    Documentation: "文檔",
    Bounty: "懸賞",
    SmartX: "SmartX",
    Github: "Github",
    Cooperation: "合作",
    CooperateWithOntology: "與本體合作",
    TrustEcosystem: "信任生態",
    Nodes: "節點",
    About: "關於",
    Press: "新聞",
    TechNews: "本體視點",
    Team: "團隊",
    AboutOntology: "關於本體",
    WhitePaper: "白皮書",
    Explorer: "區塊鏈瀏覽器",
    dApps: "dApps",
    dAppsList: "dApps 列表",
    SubmitAdApp: "提交 dApp",
    node: "節點",

    aboutUs: "關於我們",
    joinUs: "加入我們",
    Branding: "品牌規範",
    Partners: "合作夥伴",
    ContactUs: "聯繫我們",
    useOntology: "使用本體網络",
    OntOng: "ONT & ONG",
    Bridge: "橋",
    NodesStaking: "節點 & 質押",
    OWallet: "OWallet",
    ONTO: "ONTO錢包",
    Developers: "開發者",
    GetTestnetTokens: "水龍頭",
      StakeOnt: "質押ONT",
      stONT: 'stONT',
      Docs: 'Docs',
    Calculator: "收益計算機",
    RunANode: "運行節點",
    Discord: "Discord",
    CommunityForm: "Community Forum",
  },
};
